import renderImage from '@/globalComponents/renderImage.vue'
export default {
  install(Vue) {
    Vue.component('RenderImage', renderImage)
  }
}
